import { XML_ScaleAndShiftY } from "./XML_ScaleAndShiftY";
import { XML_ScaleAndShiftX } from "./XML_ScaleAndShiftX";
import { XML_AddSingle } from "./XML_AddSingle";
import { XML_AddPair } from "./XML_AddPair";
import { XML_Cmd2 } from "./XML_Cmd2";
import { XML_Cmd3 } from "./XML_Cmd3";

export function XML_DrawLinePDF(x1, y1, x2, y2, lineColor, thickness, dashed, drawElement, layer) {
  x1 = XML_ScaleAndShiftX(x1, drawElement, layer);
  x2 = XML_ScaleAndShiftX(x2, drawElement, layer);
  y1 = XML_ScaleAndShiftY(y1, drawElement, layer);
  y2 = XML_ScaleAndShiftY(y2, drawElement, layer);

  y1 = drawElement.ConvertY(y1);
  y2 = drawElement.ConvertY(y2);

  var s = drawElement.GetStream();
  XML_AddSingle(0, "c", drawElement); // CB - Is this even necessary?

  drawElement.OutputElementHead(s, "li");
  XML_AddPair(x1, y1, "mt", drawElement);
  XML_AddPair(x2, y2, "lt", drawElement);
  drawElement.OutputElementTail(s, "li");

  if (dashed) {
    //var p = XML_GetDashParam(thickness);
    //XML_Cmd4("stk",lineColor,thickness,p.fX, p.fY,drawElement);
    XML_Cmd3("stk", lineColor, thickness, 1, drawElement);
  } else XML_Cmd2("stk", lineColor, thickness, drawElement);
}
